import { AUTH_ENVS, getAuthEnv } from "./authEnvs";

export const USER_INFO = "user_info";
export const REFRESH_TOKEN_EXPIRY_TIME = "ref_token_expiry";

// The user's auth environment, or the build's first one when the site can't
// tell (callers that must ask instead check getAuthEnv() themselves).
const envOrDefault = (env) => env ?? getAuthEnv() ?? AUTH_ENVS[0];

// Build the portal login URL with a `redirect` param pointing back to the page
// the user is currently on, so the portal can return them here after login.
// Uses the full current URL (including path + query) so deep links are preserved.
export const getLoginUrlWithRedirect = (env) => {
  const returnUrl = window.location.href;
  return `${envOrDefault(env).authUrl}/login?redirect=${encodeURIComponent(returnUrl)}`;
};

// Build the portal logout URL with a `redirect` param pointing back to the
// Integration site's home, so that after the user logs out and signs in again
// the portal returns them here rather than leaving them on the portal.
export const getLogoutUrlWithRedirect = (env) => {
  const returnUrl = window.location.origin;
  return `${envOrDefault(env).authUrl}/logout?redirect=${encodeURIComponent(returnUrl)}`;
};

// The portal the user signed in at (the logo's "back to portal" link).
export const getPortalUrl = (env) => envOrDefault(env).authUrl;
